import { PreCompHttpHelper, NO_DATA_MESSAGE } from '../../utils/HttpHelper';

const SearchPreCompOrganizationData = (filterObj, sortByValue, state, setState) => {
  if (state.isArrayLoading !== true && !state.message) {
    const newState = {
      ...state,
      isArrayLoading: true,
      isArrayLoaded: false,
      message: 'Loading...'
    };
    setState(newState);

    const filterObjectString = JSON.stringify(filterObj);
    const filterObjectStringForUrl = filterObjectString ? encodeURIComponent(filterObjectString) : 'NaN';
    filterObjectStringForUrl.replace('&', '%26');
    const url = `/PreCompetitiveOrganization/search?filters=${filterObjectStringForUrl}&sortBy=${sortByValue}`;
    PreCompHttpHelper(url, 'GET')
      .then((arrayData) => {
        if (!arrayData) {
          throw new Error(NO_DATA_MESSAGE);
        } else {
          setState({
            ...newState,
            isArrayLoading: false,
            isArrayLoaded: true,
            arrayData,
            message: ''
          });
        }
      })
      .catch((e) => {
        const message = e && e.message ? e.message : NO_DATA_MESSAGE;
        setState({
          ...newState,
          isArrayLoading: false,
          isArrayLoaded: false,
          message: message
        });
      });
  }
};

export default SearchPreCompOrganizationData;